module.exports = __webpack_public_path__ + "img/4.99014742.jpg";